<template>
  <div class="sample-list">
    <div class="sample-item" v-for="(item, index) in sampleList" :key="index">
      <el-form label-position="right" label-width="168px" :model="item" :rules="sampleRules" :ref="'sample' + index">
        <div class="sample-title" v-if="commonProps.isOiq"><span>{{item.row}}#</span> {{item.sampleName}}</div>
        <div class="ind-sample-title" v-else>{{index + 1}}#</div>
        <el-row :gutter="47">
          <el-col :span="24 / item2.rowNum" v-for="item2 in item.sampleFromDTOList" :key="item2.sampleKey">
            <el-form-item :label="item2.sampleKeyName" :prop="item2.sampleKey" :rules="getRules(item2, item)" v-if="getShow(item2, item)" :class="{'is-required': item2.isMust}">
              <el-input v-if="item2.type === 0" :placeholder="item2.fillNotice" v-model="item[item2.sampleKey]" :disabled="applicationDiabled || disabledAll" :maxlength="item2.fillLen"></el-input>
              <el-checkbox-group v-if="item2.type === 11" v-model="item[item2.sampleKey]" :disabled="commonProps.disabledAll">
                <template v-for="v in item2.enums">
                  <el-checkbox :label="v.enumCode" :disabled="handleDisable(v, item[item2.sampleKey])" :key="v.enumCode">
                    <span v-html="v.enumName"></span>
                  </el-checkbox>
                  <template v-if="v.isFill">
                    <el-input :key="v.enumCode + '1'" :disabled="applicationDiabled || commonProps.disabledAll" v-if="showInput(v, item, item2.sampleKey)" :placeholder="v.remark" v-model="item[item2.sampleKey + 'RemarkPage']" :maxlength="item2.fillLen"/>
                  </template>
                </template>
              </el-checkbox-group>
            </el-form-item>
            <div class="sample-divider" v-if="item2.showAttr.bottomDivider && item[item2.sampleKey].length">
              <el-divider>{{item2.showAttr.bottomDivider}}</el-divider>
            </div>
          </el-col>
        </el-row>
      </el-form>
      <div class="btns" v-if="!disabledAll && !commonProps.isOiq">
        <el-button type="text" class="add-sample" @click="addSample(index, item)" v-if="sampleList.length < 30"><img src="../../assets/images/apply/add.png" alt="">复制样品</el-button>
        <el-button type="text" class="del-sample" v-if="sampleList.length!==1" @click="delSample(index)"><img src="../../assets/images/apply/del.png" alt="">删除样品</el-button>
      </div>
    </div>
    <el-button class="common-btn" @click="addSample(sampleList.length-1, basicSample)" v-if="sampleList.length < 30 && !disabledAll && !commonProps.isOiq && commonProps.form.orderBase.businessCode">+添加样品信息</el-button>
  </div>
</template>

<script>
import expandIcon from '../../assets/images/spec-expand.png'
import closeIcon from '../../assets/images/spec-close.png'
export default {
  name: 'TicSample',
  props: {
    required: {
      type: Object,
      default() {
        return {}
      }
    },
    requiredEn: {
      type: Object,
      default() {
        return {}
      }
    },
    basicSample: {
      type: Object,
      default() {
        return {}
      }
    },
    commonProps: {
      type: Object,
      default() {
        return {}
      }
    },
    applicationDiabled: {
      type: Boolean,
      default: false
    },
    disabledAll: {
      type: Boolean,
      default: false
    },
    list: {
      type: Array,
      default() {
        return []
      }
    },
    reportLuaCode: {
      type: String,
      default: 'ZN'
    },
  },
  data() {
    return {
      sampleList: [],
      sampleRules: {
        sampleNameCn:[this.required],
        sampleNameEn:[this.requiredEn]
      },
      expandIcon,
      closeIcon
    }
  },
  watch: {
    list: {
      handler(val) {
        // this.sampleList = JSON.parse(JSON.stringify(val))
        this.sampleList = val
        // this.$emit('updateSampleList', this.sampleList)
      },
      immediate: true
    }
  },
  methods: {
    showInput(data, form, key) {
      if (form[key] && form[key].includes(data.enumCode)) {
        return true
      }
      form[key + 'RemarkPage'] = ''
      return false
    },
    handleDisable(data, value) {
      const arr = data.enumExtend ? data.enumExtend.split(',') : []
      return arr.some(v => value.includes(v))
    },
    getShow(data, sample) {
      let result = false
      const attrRules = data.attrRules
      if (!attrRules || !attrRules.length) {
        result = true
      } else {
        result = attrRules.some(item => {
          return item.conditions.some(v => {
            const matchValArr = v.matchValue.split(',')
            return matchValArr.some(value => sample[v.matchKey] && sample[v.matchKey].includes(value))
          })
        })
      }
      let luaResult = data.lua === 'CHI' && this.reportLuaCode !== 'EN' || data.lua === 'EN' && this.reportLuaCode !== 'ZN' || data.lua === 'CHI-EN'
      return result && luaResult
    },
    getRules(data, item) {
      const arr = []
      if (data.isMust) {
        arr.push(this.required)
      }
      if (this.reportLuaCode !== 'ZN' && this.reportLuaCode !== 'EN') {
        const validate = (rule, value, callback) => {
          if (this.commonProps.isSave && !value && item.sampleFromGoup[data.sampleGroup].some(v => v !== data.sampleKey && item[v])) {
            return callback(new Error('必填项'));
          } else {
            return callback()
          }
        }
        arr.push({ validator: validate })
      }
      if (data.showAttr.remarkRequired) {
        const validator = (rule, value, callback) => {
          const formatValue = typeof value === 'string' ? [value] : value
          if (value && formatValue.includes(data.showAttr.remarkRequired) && !item[data.sampleKey + 'RemarkPage']) {
            return callback(new Error('请填写'));
          } else {
            return callback()
          }
        }
        arr.push({ validator, trigger: ['change', 'blur'] })
      }
      return arr
    },
    addSample(index, copySample) {
      let sample = JSON.parse(JSON.stringify(copySample))
      sample.sampleNo = new Date().getTime() + String.fromCharCode(65 + Math.floor(Math.random() * 26))
      this.sampleList.splice(index+1, 0, sample)
    },
    delSample(index) {
      const delSample = this.sampleList[index]
      this.$emit('delSample', delSample)
      this.sampleList.splice(index, 1)
    },
    changeSpecExpand(data) {
      this.$set(data, 'isExpand', !data.isExpand)
    },
    validateForm(key, isArr) {
      if (isArr) {
        return new Promise(resolve => this.$refs[key][0].validate(resolve))
      }
      return new Promise(resolve => this.$refs[key].validate(resolve))
    },
    getValidate() {
      const arr = []
      this.sampleList && this.sampleList.forEach((v, index) => {
        const key = 'sample' + index
        arr.push(this.validateForm(key, true))
      })
      return arr
    },
    getSample() {
      this.sampleList.forEach((v, index) => {
        v.sampleFromDTOList.forEach(item => {
          item.sampleValue = ''
          item.remark = ''
          if (this.getShow(item, v)) {
            item.sampleValue = v[item.sampleKey]
            item.remark = v[item.sampleKey + 'RemarkPage']
            if (item.type === 11) item.sampleValue = v[item.sampleKey].join(',')
          }
        })
      })
      return JSON.parse(JSON.stringify(this.sampleList))
    }
  }
};
</script>

<style scoped lang="scss">
::v-deep .el-form-item__content .el-checkbox__label {
  line-height: 40px;
}
.sample-divider {
  padding-left: 32.5px;
  width: calc(100% + 96px);
  margin-bottom: 30px;
  position: relative;
  top: -10px;
  .el-divider--horizontal {
    background: #DFDFDF;
  }
  .el-divider__text {
    background: #F5F5F5;
    font-size: 12px;
    color: #999999;
  }
}
.sample-list {
  position: relative;
  .btns {
    position: absolute;
    top: 15px;
    right: 28px;
    .el-button {
      display: block;
      margin-left: 0;
    }
  }
}
  .sample-item {
    background: #F5F5F5;
    margin-bottom: 16px;
    padding: 15px 148px 6px 0;
    position: relative;
    .ind-sample-title {
      color: rgb(255, 102, 0);
      font-size: 14px;
      font-weight: 700;
      line-height: 14px;
      position: absolute;
      top: 28px;
      left: 25px;
    }
    .sample-title {
      font-size: 14px;
      line-height: 14px;
      color: #333333;
      padding: 4px 25px 15px;
      span {
        color: #FF6600;
      }
    }
    .add-sample, .del-sample {
      font-size: 14px;
      color: #CA4300;
      padding: 10.5px 0;
      img {
        vertical-align: text-top;
        margin-right: 10px;
      }
    }
    .del-sample {
      color: #878787;
      margin-top: 15px;
      img {
        margin-right: 12px;
      }
    }
  }
</style>
<style lang="scss">
.create-form .sample-list {
  .common-btn {
    background: rgba(255, 102, 0, 0.05);
    width: 142px;
  }
  .el-form-item {
    margin-bottom: 15px;
  }
}
</style>
